import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateAsset($companyId: ID!, $id: ID!, $attributes: AssetAttributes!) {
    updateAsset(companyId: $companyId, id: $id, attributes: $attributes) {
      asset {
        id
        ...UpdatedAsset
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedAsset on Asset {
    id
    assetType { id name }
    barcode { barcode }
    serialNumber
    warehouse {
      id
      name
    }
    notes
    mystroTestId
  }
`
